import { Laptop, MapPin } from "lucide-react";
import { SectionHeading } from "@/components/common/SectionHeading";
import { Reveal } from "@/components/common/Reveal";
import { WHY } from "@/lib/site";

const MODES = [
  { icon: Laptop, label: "Online courses" },
  { icon: MapPin, label: "At MUCCI locations" },
];

export const WhySection = () => (
  <section className="section-y" aria-labelledby="why-title" data-testid="why-section">
    <div className="container-x grid gap-14 lg:grid-cols-[1fr_1.2fr]">
      <div>
        <SectionHeading id="why-title" eyebrow="Why MUCCI" title="Minds United for Curiosity, Creativity & Innovation"
          intro="For students, parents and homeschooling families who want learning that feels alive." />
        <Reveal delay={0.1} className="mt-10 card-soft p-7">
          <h3 className="text-xl font-semibold">Learn the way that suits you</h3>
          <ul className="mt-5 space-y-3">
            {MODES.map(({ icon: Icon, label }) => (
              <li key={label} className="flex items-center gap-3 font-semibold">
                <span className="grid h-9 w-9 place-items-center rounded-full bg-mint"><Icon className="h-4 w-4" aria-hidden="true" /></span>
                {label}
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
      <div className="grid content-center gap-5">
        {WHY.map((w, i) => (
          <Reveal key={w.title} delay={i * 0.1}>
            <div className={`flex gap-6 rounded-card ${w.color} p-8 transition-transform duration-300 hover:-translate-y-1`} data-testid={`why-card-${i}`}>
              <span className="font-heading text-6xl font-semibold leading-none text-ink/25" aria-hidden="true">{i + 1}</span>
              <div>
                <h3 className="text-2xl font-semibold">{w.title}</h3>
                <p className="mt-2 text-ink leading-relaxed">{w.text}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
